import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const PainPointsForm = ({ formData, updateFormData, errors }) => {
  const painPointOptions = [
    { value: 'data_entry', label: 'Ingreso manual y duplicado de datos' },
    { value: 'document_processing', label: 'Lectura y extracción lenta de documentos' },
    { value: 'slow_comms', label: 'Comunicaciones y seguimientos lentos' },
    { value: 'human_errors', label: 'Alta tasa de errores humanos' },
    { value: 'data_silos', label: 'Sistemas desconectados que no se hablan' },
    { value: 'scalability', label: 'Imposibilidad de escalar sin contratar más' },
    { value: 'decision_making', label: 'Toma de decisiones sin datos en tiempo real' },
    { value: 'high_costs', label: 'Altos costos operativos en tareas básicas' }
  ];

  const urgencyOptions = [
    { value: 'immediate', label: 'Inmediato (1-3 meses)' },
    { value: 'short_term', label: 'Corto plazo (3-6 meses)' },
    { value: 'medium_term', label: 'Mediano plazo (6-12 meses)' },
    { value: 'long_term', label: 'Largo plazo (12+ meses)' }
  ];

  //esto entra a planificacion cuando tengamos mas estables los precios 
  //const budgetRangeOptions = [
   // { value: '10k-25k', label: '$10,000 - $25,000 USD' },
    //{ value: '25k-50k', label: '$25,000 - $50,000 USD' },
    //{ value: '50k-100k', label: '$50,000 - $100,000 USD' },
    //{ value: '100k-250k', label: '$100,000 - $250,000 USD' },
    //{ value: '250k+', label: 'Más de $250,000 USD' },
    //{ value: 'not_defined', label: 'Aún no definido' }
  //];

  const impactAreasOptions = [
    { value: 'productivity', label: 'Multiplicar la productividad del equipo' },
    { value: 'costs', label: 'Reducción drástica de costos operativos' },
    { value: 'accuracy', label: 'Eliminación de errores (100% Precisión)' },
    { value: 'customer_satisfaction', label: 'Tiempos de respuesta inmediatos' },
    { value: 'scalability', label: 'Capacidad de escalar sin límite' },
    { value: 'insights', label: 'Visibilidad de datos en tiempo real' }
  ];

  const handlePainPointChange = (value, checked) => {
    const painPoints = formData.painPoints || [];
    if (checked) {
      updateFormData('painPoints', [...painPoints, value]);
    } else {
      updateFormData('painPoints', painPoints.filter(item => item !== value));
    }
  };

  const handleImpactAreaChange = (value, checked) => {
    const impactAreas = formData.expectedImpactAreas || [];
    if (checked) {
      updateFormData('expectedImpactAreas', [...impactAreas, value]);
    } else {
      updateFormData('expectedImpactAreas', impactAreas.filter(item => item !== value));
    }
  };

  return (
    <div className="space-y-8">
      <div>
        <h4 className="text-lg font-bold text-slate-900 mb-4">Principales Desafíos</h4>
        <CheckboxGroup 
          label="¿Cuáles son sus principales desafios operativos?"
          description="Seleccione todos los problemas que enfrenta actualmente"
          error={errors.painPoints}
        >
          <div className="grid grid-cols-1 gap-3">
            {painPointOptions.map((option) => (
              <Checkbox
                key={option.value}
                label={option.label}
                checked={(formData.painPoints || []).includes(option.value)}
                onChange={(e) => handlePainPointChange(option.value, e.target.checked)}
              />
            ))}
          </div>
        </CheckboxGroup>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Urgencia del Proyecto"
          placeholder="¿Cuándo necesita implementar la solución?"
          options={urgencyOptions}
          value={formData.urgency || ''}
          onChange={(value) => updateFormData('urgency', value)}
          error={errors.urgency}
          required
        />

       
      </div>

      <div>
        <h4 className="text-lg font-bold text-slate-900 mb-4">Impacto Esperado</h4>
        <CheckboxGroup 
          label="¿En qué áreas espera ver mejoras?"
          description="Seleccione las áreas donde espera obtener beneficios"
          error={errors.expectedImpactAreas}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {impactAreasOptions.map((option) => (
              <Checkbox
                key={option.value}
                label={option.label}
                checked={(formData.expectedImpactAreas || []).includes(option.value)}
                onChange={(e) => handleImpactAreaChange(option.value, e.target.checked)}
              />
            ))}
          </div>
        </CheckboxGroup>
      </div>

      <Input
        label="Objetivos Específicos"
        type="text"
        placeholder="Describa los objetivos específicos que espera lograr con la automatización"
        value={formData.specificGoals || ''}
        onChange={(e) => updateFormData('specificGoals', e.target.value)}
        error={errors.specificGoals}
        description="Ej: Reducir tiempo de lectura de escrituras de 3 horas a 5 minutos"
      />

      <Input
        label="Información Adicional"
        type="text"
        placeholder="Cualquier información adicional que considere relevante para la consultoría"
        value={formData.additionalInfo || ''}
        onChange={(e) => updateFormData('additionalInfo', e.target.value)}
        error={errors.additionalInfo}
        description="Comparta cualquier detalle que pueda ayudarnos a preparar mejor la consultoría"
      />
    </div>
  );
};

export default PainPointsForm;